export default __webpack_public_path__ + "9f0d6f6e242ade8803d7fc4db0222718.svg";